import { render, staticRenderFns } from "./LawDecisionList.vue?vue&type=template&id=6ff07a21&"
import script from "./LawDecisionList.vue?vue&type=script&lang=js&"
export * from "./LawDecisionList.vue?vue&type=script&lang=js&"
import style0 from "./LawDecisionList.vue?vue&type=style&index=0&id=6ff07a21&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports